import { RoleInternal } from '../models/RoleInternal.interface';
import { roles } from './config/roles';
import { Policy } from './policies';

const REGEXP_INTERPOLATION = /\${([a-zA-Z]+)\}/;

interface TeamRoleParams {
    account: string;
    teamId: string;
}

interface UserRoleParams {
    account: string;
    userId: string;
}

export class Role {
    name!: string;
    shortName!: string;
    description!: string;
    policies: Policy[];

    constructor(role: RoleInternal) {
        this.policies = [];
        this.description = role.description;
    }

    buildShortName(): void {
        this.shortName = this.name.split('$').pop() as string;
    }
}
export class TeamRole extends Role {

    constructor( role: RoleInternal, params: TeamRoleParams) {
        super(role);
        this.buildRoleName(params);
        this.buildPolicies(params);
        this.buildShortName();
    }

    buildRoleName(data: any): void {
        this.name = roles.teamBasicAccess.name.replace(REGEXP_INTERPOLATION, (prop, $1) => {
            if (data[$1]) {
                return data[$1];
            } else {
                throw new Error("Invalid data")
            }
        });
    }

    buildPolicies(params: any): void {
        this.policies = roles.teamBasicAccess.policies.map(policy => new Policy(policy, params));
    }
}

export class UserRole extends Role {

    constructor(role: RoleInternal, params: UserRoleParams) {
        super(role);
        this.buildRoleName(params);
        this.buildPolicies(params);
        this.buildShortName();
    }

    buildRoleName(data: any): void {
        this.name = roles.fullBasicAccess.name.replace(REGEXP_INTERPOLATION, (prop, $1) => {
            if (data[$1]) {
                return data[$1];
            }
        });
    }

    buildPolicies(params: any): void {
        this.policies = roles.fullBasicAccess.policies.map(policy => new Policy(policy, params));
    }
}
